import React from 'react';

class SimpleTextarea extends React.Component{
  constructor(props) {
    super(props);
    this.state = {[props.name]:props.value};

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render () {
    const onChange = this.props.onChange ? this.props.onChange : this.handleChange;
      return (
          <textarea
            autoComplete="off"
            onChange={onChange}
            className="text-area"
            placeholder={this.props.placeholder}
            type={this.props.type}
            value={this.state[this.props.name]}
            name={this.props.name}></textarea>
      );
  }
};

export default SimpleTextarea;



// WEBPACK FOOTER //
// ./src/components/form/SimpleTextarea.js